import { render } from "./Admin.GDPR.vue?vue&type=template&id=3300f999"
import script from "./Admin.GDPR.vue?vue&type=script&lang=js"
export * from "./Admin.GDPR.vue?vue&type=script&lang=js"

import "./Admin.GDPR.vue?vue&type=style&index=0&id=3300f999&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__